import { chairsTableParasol, sunloungerParasolSunPalmtree } from '@lucide/lab';
import {
  Anchor,
  BedDouble,
  Bot,
  Building2,
  Droplets,
  Heart,
  Home,
  Hotel,
  Landmark,
  Laptop,
  Luggage,
  MessagesSquare,
  Microwave,
  Mountain,
  PlaneTakeoff,
  Refrigerator,
  Sailboat,
  Scale,
  ShoppingCart,
  Smartphone,
  Sparkles,
  Star,
  Sun,
  Tag,
  TreePalm,
  TreePine,
  Tv,
  User,
  Users,
  UtensilsCrossed,
  WashingMachine,
  createLucideIcon,
  type LucideIcon,
  type LucideProps,
} from 'lucide-react';

const ChairsTableParasol = createLucideIcon('ChairsTableParasol', chairsTableParasol);
const SunloungerParasolSunPalmtree = createLucideIcon(
  'SunloungerParasolSunPalmtree',
  sunloungerParasolSunPalmtree,
);

const ICONS: Record<string, LucideIcon> = {
  Anchor,
  BedDouble,
  Bot,
  Building2,
  ChairsTableParasol,
  Droplets,
  Heart,
  Home,
  Hotel,
  Landmark,
  Laptop,
  Luggage,
  MessagesSquare,
  Microwave,
  Mountain,
  PlaneTakeoff,
  Refrigerator,
  Sailboat,
  Scale,
  ShoppingCart,
  Smartphone,
  Sparkles,
  Star,
  Sun,
  SunloungerParasolSunPalmtree,
  Tag,
  TreePalm,
  TreePine,
  Tv,
  User,
  Users,
  UtensilsCrossed,
  WashingMachine,
};

interface DynamicIconProps extends LucideProps {
  name: string;
}

export function DynamicIcon({ name, ...props }: DynamicIconProps) {
  const IconComponent = ICONS[name] || MessagesSquare;
  return <IconComponent {...props} />;
}
